module.exports = __webpack_public_path__ + "static/media/pdf.c357cf77.svg";